import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function BillingCancelPage() {
  return (
    <div className="min-h-screen bg-[#050505] text-zinc-100 font-mono flex items-center justify-center p-6">
      <div className="max-w-md w-full border border-[#27272A] bg-[#0B0B0B] p-8 flex flex-col items-center gap-4"
           data-testid="billing-cancel-panel">
        <XCircle className="text-zinc-400" size={44} />
        <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-400">CHECKOUT_CANCELED</div>
        <p className="text-[13px] text-zinc-300 text-center">
          No worries — no charge was made. You can restart the checkout any time from the pricing page.
        </p>
        <Link to="/pricing" data-testid="billing-cancel-back-pricing"
              className="px-4 py-2 text-[11px] uppercase tracking-[0.2em] border border-emerald-500/50 bg-emerald-500/10 hover:bg-emerald-500/20 text-emerald-200">
          RETURN_TO_PRICING
        </Link>
      </div>
    </div>
  );
}
